const MODULE_URL = 'hash';
export default {
  MODULE_URL: MODULE_URL,
  OPTIMIZE_DATABASE_URL: MODULE_URL + '/optimize_database',
  DATABASE_STATUS_URL: MODULE_URL + '/database_status',
  STATS_URL: MODULE_URL + '/stats',

  PAUSE_URL: MODULE_URL + '/pause',
  RESUME_URL: MODULE_URL + '/resume',
  STOP_URL: MODULE_URL + '/stop',

  DATABASE_STATUS: 'hash_database_status',
  STATISTICS: 'hash_statistics',
};
